import React from 'react';

/**
 * A simple component to display day badges for a fixed flow.
 * Isolated from the main file to avoid babel-metadata-plugin issues.
 */
const FlowDayBadges = ({ dayTemplates }) => {
  // Default days if no custom templates
  const defaultDays = [1, 7, 30, 60, 90, 365];
  
  // Get days to display
  const getDays = () => {
    if (!dayTemplates || dayTemplates.length === 0) {
      return defaultDays;
    }
    const days = [];
    for (let i = 0; i < dayTemplates.length; i++) {
      if (dayTemplates[i].day) {
        days.push(dayTemplates[i].day);
      }
    }
    days.sort((a, b) => a - b);
    return days;
  };
  
  // Check if a day has a template assigned
  const hasTemplateForDay = (day) => {
    if (!dayTemplates) return false;
    for (let i = 0; i < dayTemplates.length; i++) {
      if (dayTemplates[i].day === day && dayTemplates[i].template_id) {
        return true;
      }
    }
    return false;
  };
  
  const days = getDays();
  
  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {days.map((day) => (
        <span 
          key={day}
          className={`px-2 py-1 text-xs rounded ${
            hasTemplateForDay(day) 
              ? 'bg-[#4F46E5]/10 text-[#4F46E5]' 
              : 'bg-gray-100 text-gray-400'
          }`}
        >
          Day {day}
        </span>
      ))}
    </div>
  );
};

export default FlowDayBadges;
